'use client';

import { Breadcrumbs, IBreadcrumbTitles } from 'components/Breadcrumbs';
import { UpArrow } from 'components/UpArrow';
import Script from 'next/script';
import { useEffect, useState } from 'react';
import getSearchClient from 'server/repository/algolia/client';
import { GetGenericPageQuery } from 'server/repository/hygraph/generated/graphqlTypes';

import TemplateMapper from 'templates/TemplateMapper';
import type { AvailableTemplates } from 'templates/TemplateMapper/types';
import type { DictionaryItem } from 'service/dictionary/dictionaryService';
import type { IGlobalMetaData } from 'types/GlobalMetadata';
import { TrackingService } from 'service/tracking/trackingService';

type SearchOverlay = {
  subHeading?: string | null;
  heading?: string | null;
  searchClient?: any;
  indices: {
    recipes: string;
    articles: string;
    tipsAndTricks: string;
    products: string;
  };

  query: string | null;
  linkText: string | null;
  copy: object;
};

const ClientSupportPage = ({
  breadcrumbsCMSData,
  data,
  globalMetadata,
  searchOverlayData,
  difficultyCopy,
  recipeCopy,
  searchItemLabels,
}: {
  breadcrumbsCMSData: IBreadcrumbTitles;
  data: GetGenericPageQuery;
  globalMetadata: IGlobalMetaData | null;
  searchOverlayData: SearchOverlay;
  recipeCopy: DictionaryItem[];
  difficultyCopy: Record<string, string>;
  searchItemLabels: Record<string, string>;
}) => {
  const page = data.genericPages?.[0] || {};
  const [searchOverlayDataExtended, setSearchOverlayDataExtended] = useState(searchOverlayData);

  useEffect(() => {
    if (!searchOverlayDataExtended.searchClient) {
      const algoliaClient = getSearchClient();
      setSearchOverlayDataExtended({
        ...searchOverlayDataExtended,
        searchClient: algoliaClient,
      });
    }
  }, [searchOverlayData]);

  useEffect(() => {
    const cg1 = page?.contentGroupingTrackingValue;
    const cg2 = page?.contentGroupingTrackingValues;
    if (cg1) {
      if (cg2) {
        TrackingService.contentGroups({
          cg1: cg1.replace(/_/g, ' '),
          cg2: cg2.replace(/_/g, ' '),
        });
      } else {
        TrackingService.contentGroups({
          cg1: cg1.replace(/_/g, ' '),
        });
      }
    }
  }, []);

  return (
    <>
      {page?.cookieBannerRequired === false && (
        <Script type="application/javascript" id="suppress-cookie-banner">
          var UC_UI_SUPPRESS_CMP_DISPLAY=true;
        </Script>
      )}
      <Breadcrumbs isPositionRelative titles={breadcrumbsCMSData} pageName={page.title} />
      <TemplateMapper
        components={page?.pageComponents as AvailableTemplates[]}
        copy={page?.dictionary?.dictionaryItems ?? []}
        recipeCopy={recipeCopy}
        difficultyCopy={difficultyCopy}
        globalMetadata={globalMetadata ?? {}}
        searchItemLabels={searchItemLabels}
        searchData={searchOverlayDataExtended}
      />
      <UpArrow />
    </>
  );
};

export default ClientSupportPage;
